import { FaTools, FaHammer, FaCrown } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaTools />, // Basic Package Icon
        title: 'Basic Package',
        price: 1499.00,
        features: [
            'Roof Inspection',
            'Basic Repairs',
            'Standard Shingle Installation',
            '5-Year Warranty',
            'Free Estimate',
        ],
    },
    {  
        id: 2, 
        image: images.plan2,
        icon: <FaHammer />, // Standard Package Icon
        title: 'Standard Package',
        price: 2999.00,
        features: [
            'Comprehensive Roof Inspection',
            'Moderate Repairs',
            'High-Quality Shingle Installation',
            '10-Year Warranty',
            'Gutter Cleaning',
        ],
    },
    {  
        id: 3,
        image: images.plan3,
        icon: <FaCrown />, // Premium Package Icon
        title: 'Premium Package',
        price: 4999.00,
        features: [
            'Detailed Roof Inspection',
            'Extensive Repairs',
            'Premium Shingle Installation',
            '20-Year Warranty',
            'Skylight Installation',
        ],
    },
];

export default pricing;